const Banner = {
  getBanners: 'Banner',
};

export default Banner;
